// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1f9wl","productName":"Table_productName__10n5d"};